import rfdc from 'rfdc'

export const deepClone = item => rfdc()(item)
